import { Params } from '@angular/router';
import { DateOption, isSelectedOrganizationFilters, SelectedOrganizationFilters, SelectedProgramFilters } from '../../../models/filters.model';

// null values remove the key when navigating with queryParamsHandling: 'merge'
export function filtersToQueryParams(filters: SelectedProgramFilters | SelectedOrganizationFilters): Params {
  const isCustom = filters.dateOption === DateOption.customPeriod;
  const dates = {
    range: filters.dateOption,
    from: isCustom ? filters.dateRange.start.format('YYYY-MM-DD') : null,
    to: isCustom ? filters.dateRange.end.format('YYYY-MM-DD') : null,
  };

  return isSelectedOrganizationFilters(filters)
    ? { org: filters.organization.id, sites: filters.sites.map((s) => s.id).join(',') || null, program: null, products: null, ...dates }
    : { program: filters.program.id, products: filters.products.map((p) => p.id).join(',') || null, org: null, sites: null, ...dates };
}

export const splitIds = (value?: string): string[] => (value ? value.split(',') : []);